import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player/lazy";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import axios, { AxiosError } from "axios";
import Navbar from "../components/Navbar";
import Modal from "../components/Modal";
import { VideoType } from "../utils/types";
import SlideShow from "../components/Slides";
import colors from "../utils/colors";
// import progressbar from "../assets/progressbar.gif";
import "./style.css";

interface PreviewPropsType {
  url: string;
}

const initialValue = {
  _id: "",
  camera: "",
  date: "",
  dateRough: "",
  insight: "",
  keywords: [""],
  suburb: "",
  name: "",
  orientation: "",
  postcode: "",
  provider: "",
  sensitivity: "",
  street: "",
  thumbnail: [""],
  videoURL: "",
  videoPreviewURL: "",
  duration: 0,
  locality: "",
  location: { type: "", coordinates: [] },
};

interface PublishSuccess {
  success: string;
  errormsg: string;
}

function Preview(props: PreviewPropsType) {
  const [isFetching, setIsFetching] = useState(true);
  const [isPublishing, setIsPublishing] = useState(false);
  const [isPublishSuccess, setIsPublishSuccess] = useState<PublishSuccess>({
    success: "not start",
    errormsg: "",
  });
  const [mode, setMode] = useState("high");
  const [percentage, setPercentage] = useState(0);
  const [data, setData] = useState<VideoType>(initialValue);
  console.log(data);
  const videoURL = data.videoURL.replace("stream", "streamwithname");
  const videoPreviewURL = data.videoPreviewURL.replace(
    "stream",
    "streamwithname"
  );

  console.log("videoURL", videoURL, videoPreviewURL);
  console.log("isPublishSuccess", isPublishSuccess);

  const { url } = props;
  const { id } = useParams();
  const slsApi = process.env.REACT_APP_create_video_api;

  const getData = async () => {
    console.log("getting data now");
    try {
      const res = await axios.get(`${slsApi}/${id}`);
      console.log(res);
      setPercentage(res.data.progress);
      if (res.data.videoURL !== res.data.videoPreviewURL) {
        setIsFetching(false);
        setData(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  //create publish to smods.org function
  const fetchImage = (url: string) => {
    let imgName = "";
    imgName = url.split("name").pop()!;

    console.log("imgName", imgName);

    fetch(url).then((response: any) => {
      response
        .blob()
        .then((blob: any) => {
          console.log("downloading image now");
          // Creating new object
          const fileURL = window.URL.createObjectURL(blob);
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = imgName;
          alink.click();
        })
        .catch((err: any) => console.error(err));
    });
  };

  const navigate = useNavigate();

  const publishToSmods = async () => {
    console.log("publishTOsmods,data", data);
    setIsPublishing(true);
    // Publish promotes the video from sls into the central DSP tenant.
    const publishApi = process.env.REACT_APP_DSP_PUBLISH_API as string;
    if (data._id) {
      console.log("This video id exists");
      // const urls = data.thumbnail;
      // urls.forEach(async (url) => {
      //   await fetchImage(url);
      // });
      try {
        const res = await axios.post(publishApi, data);
        if (res.status === 201) {
          setTimeout(() => {
            setIsPublishSuccess({ ...isPublishSuccess, success: "success" });
          }, 2000);

          setTimeout(() => {
            setIsPublishing(false);
            navigate("/sls");
          }, 4000);
        }
        console.log("res", res);
      } catch (err: any) {
        setIsPublishSuccess({
          success: "error",
          errormsg: err?.response?.data?.msg || err?.message || "Publish failed",
        });
        console.log(err, isPublishSuccess);
      }
      // axios
      //   .post(`${dspPublishApi}`, data)
      //   .then((res) => console.log(res.data))
      //   .catch((err) => console.log(err));
    }
  };

  //when loading the page calling api to get data, before getting the correct data it will keep calling the api every 5 seconds, after get the correct data it will stop calling api.
  useEffect(() => {
    getData();
    let timer: any;
    if (isFetching) {
      timer = setInterval(() => {
        getData();
      }, 3000);
    }

    return () => {
      console.log("clearing timer now");
      clearInterval(timer);
    };
  }, [isFetching]);

  // const getData = async () => {
  //   console.log("getting data now");
  //   try {
  //     const res = await axios.get(`${slsApi}/${id}`);
  //     console.log(res);
  //     if (res.data.videoURL !== res.data.videoPreviewURL) {
  //       setIsFetching(false);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // if (!isFetching) {
  //   console.log("clearing timer now");
  //   clearInterval(timer);
  // }

  // useEffect((),[])
  // getData();
  console.log("id", id);
  const smods = process.env.REACT_APP_SMODS_URL;
  console.log(smods);

  const controlClickHandler = (props: string) => {
    console.log(props);
    setMode(props);
  };

  const PreviewNav = () => (
    <div className="previewNav">
      <div id="previewProvider">Preview video modes</div>
      {/* <div style={{ height: "1px" }}></div> */}

      <div
        onClick={() => controlClickHandler("high")}
        className={mode === "high" ? "preview-hmln preview-div" : "preview-div"}
      >
        <div
          className={mode === "high" ? " previewDot bgred" : "previewDot"}
        ></div>
        <div style={{ marginLeft: "15px" }}>HIGH CONTROL</div>
      </div>
      <div
        onClick={() => controlClickHandler("moderate")}
        className={
          mode === "moderate" ? "preview-hmln preview-div" : "preview-div"
        }
      >
        <div
          className={mode === "moderate" ? " previewDot bgblue" : "previewDot"}
        ></div>
        <div style={{ marginLeft: "15px" }}>MODERATE CONTROL</div>
      </div>
      <div
        onClick={() => controlClickHandler("low")}
        className={mode === "low" ? "preview-hmln preview-div" : "preview-div"}
      >
        <div
          className={mode === "low" ? " previewDot bggreen" : "previewDot"}
        ></div>
        <div style={{ marginLeft: "15px" }}>LOW CONTROL</div>
      </div>
      <div
        onClick={() => controlClickHandler("no")}
        className={mode === "no" ? "preview-hmln preview-div" : "preview-div"}
      >
        <div
          className={mode === "no" ? " previewDot bgblack" : "previewDot"}
        ></div>
        <div style={{ marginLeft: "15px" }}>NO CONTROL</div>
      </div>
      <div id="previewProvider2" onClick={publishToSmods}>
        Publish to SMODS
      </div>
      <div style={{ width: "100%" }}>
        {/* <Button
          variant="primary"
          style={{ marginBottom: "30px" }}
          size="lg"
          onClick={publishToSmods}
        >
          Publish to SMODS
        </Button> */}
      </div>
    </div>
  );

  const ModalSubmitingContent = () => {
    if (isPublishSuccess.success === "not start") {
      return (
        <div className="modal-box">
          <p>The video is being published to SMODS ...</p>
          <div style={{ width: "100%", textAlign: "center" }}>
            <img
              src="https://miro.medium.com/v2/resize:fit:646/1*TW6dDGBgPuZyL19TVa2kUQ.gif"
              alt="processing"
              style={{ width: "150px", margin: "auto" }}
            />
          </div>
        </div>
      );
    } else if (isPublishSuccess.success === "success") {
      return (
        <div className="modal-box">
          <h4>Congratulations!</h4>
          <p>
            This video has been published successfully, redirect to homepage now
            ...
          </p>
        </div>
      );
    } else if (isPublishSuccess.success === "error") {
      return (
        <div className="modal-box">
          <p>There is an error when publish to SMODS.</p>
          <p>Error message: {isPublishSuccess.errormsg}</p>
          <p>Please go back to re-upload the video</p>
        </div>
      );
    } else {
      return <div>ok</div>;
    }
  };

  return (
    <div
      style={{ background: colors.SLSsecondary, width: "100%", height: "100%" }}
    >
      <Navbar />

      <Modal isModalOpen={isFetching}>
        <div className="modal-box">
          <p>This video is being processed , please wait ...</p>
          <div style={{ width: "100%", textAlign: "center" }}>
            <img
              // src="https://media3.giphy.com/media/No3Q2COl8SEnu/giphy.gif?cid=ecf05e472ty6a5q298s1p7v7lc86k7ywc0al9urukapbz6qy&ep=v1_gifs_search&rid=giphy.gif&ct=g"
              src="https://miro.medium.com/v2/resize:fit:646/1*TW6dDGBgPuZyL19TVa2kUQ.gif"
              alt="processing"
              style={{ width: "150px", margin: "auto" }}
            />
            <h5>{percentage}%</h5>
          </div>
        </div>
      </Modal>

      <Modal isModalOpen={isPublishing}>
        <div>
          <ModalSubmitingContent />
        </div>
      </Modal>

      <div>
        <PreviewNav />
        {mode === "" && (
          <div className="previewvideo">
            <div
              style={{
                width: "90%",
                height: "50%",
                background: "#8f7cea",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                marginTop: "100px",
                justifyContent: "center",
                // color: "white",
              }}
            >
              <h2>
                Please pick a mode on the left to preview the uploaded video in
                different control modes.
              </h2>
            </div>
          </div>
        )}

        {/* <hr /> */}
        {mode === "high" && (
          <div className="previewvideo player-wrapper">
            <div className="preview-title" style={{ color: "whitesmoke" }}>
              <span className="preview_text_highlight">Raw Video</span> , can be
              accessed by{" "}
              <span className="preview_text_highlight">First responder</span>
            </div>
            <ReactPlayer
              className="player"
              url={videoURL}
              playing={true}
              controls={true}
            />
          </div>
        )}
        {mode === "moderate" && (
          <div className="previewvideo player-wrapper">
            <div className="preview-title" style={{ color: "whitesmoke" }}>
              <span className="preview_text_highlight">Masked Video</span> , can
              be accessed by{" "}
              <span className="preview_text_highlight">Officer</span>
            </div>
            <ReactPlayer
              className="player"
              url={videoPreviewURL}
              playing={true}
              controls={true}
            />
          </div>
        )}
        {/* <hr /> */}
        {mode === "low" && (
          <div className="previewvideo preview-slides">
            {/* <div>
              <Card
                style={{
                  width: "350px",
                  height: "150px",
                  marginRight: "150px",
                  backgroundColor: "rgb(222,222,222)",
                  border: "none",
                }}
              >
                <Card.Title style={{ lineHeight: "150px", fontSize: "30px" }}>
                  <span style={{ color: "green" }}> LOW </span>
                  <span style={{ color: "blue" }}> CONTROL</span>
                </Card.Title>
              </Card>
            </div> */}
            <div className="preview-title2" style={{ color: "whitesmoke" }}>
              <span className="preview_text_highlight">Video pictures</span> ,
              can be accessed by{" "}
              <span className="preview_text_highlight">On-call responder</span>
            </div>
            <div>
              <SlideShow thumbnail={data.thumbnail} />
            </div>
          </div>
        )}
        {/* <hr /> */}
        {mode === "no" && (
          <div className="previewvideo">
            {/* <div>
              <Card
                style={{
                  width: "350px",
                  height: "150px",
                  marginRight: "150px",
                  backgroundColor: "rgb(222,222,222)",
                  border: "none",
                }}
              >
                <Card.Title style={{ lineHeight: "150px", fontSize: "30px" }}>
                  <span style={{ color: "red" }}> NO </span>
                  <span style={{ color: "black" }}> CONTROL</span>
                </Card.Title>
              </Card>
            </div> */}
            <div className="preview-title2" style={{ color: "whitesmoke" }}>
              <span className="preview_text_highlight">Video insights</span> ,
              can be accessed by{" "}
              <span className="preview_text_highlight">Public</span>
            </div>
            <div
              style={{
                width: "90%",
                height: "80%",
                minHeight: "300px",
                backgroundColor: "lightgrey",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h4>{data.insight}</h4>
              <h4>PostCode : {data.postcode}</h4>
            </div>
          </div>
        )}
      </div>
      {/* <Button
        variant="primary"
        style={{ marginBottom: "30px" }}
        size="lg"
        onClick={publishToSmods}
      >
        Publish to SMODS
      </Button> */}
    </div>
  );
}

export default Preview;
